<template>
  <PageLayout>
    <template #headerTitle>Finances</template>

    <VBusHelper :emitOnMounted="$constants.EVENTS.FEE.LIST_ALL.REFRESH" />

    <!-- TOP FILTERS -->
    <div class="space-y-6 mb-8">
      <!-- COUNTRY FILTER -->
      <div class="space-y-3">
        <label class="block text-xs font-bold text-gray-400 uppercase tracking-widest ml-1">
          🌍 Sélection du Pays
        </label>
        <div class="flex flex-wrap gap-2">
          <button
            v-for="(country, code) in $constants.FEE.COUNTRIES"
            :key="code"
            @click="selectedCountry = code"
            :class="[
              'px-6 py-3 rounded-xl font-bold transition-all flex items-center gap-2',
              selectedCountry === code
                ? 'bg-primary text-white shadow-lg'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            ]"
          >
            <span class="text-xl">{{ country.flag }}</span>
            <span>{{ country.name }}</span>
          </button>
        </div>
      </div>

      <!-- CATEGORY / GROUP FILTER -->
      <div class="space-y-3">
        <label class="block text-xs font-bold text-gray-400 uppercase tracking-widest ml-1">
          ⚙️ Groupe d'opérations
        </label>
        <div class="flex flex-wrap gap-2">

          
          <button
            v-for="(catInfo, catKey) in visibleCategories"
            :key="catKey"
            @click="selectedCategory = catKey"
            :class="[
              'px-6 py-3 rounded-xl font-bold transition-all flex items-center gap-2',
              selectedCategory === catKey
                ? 'bg-primary text-white shadow-lg'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            ]"
          >
            {{ catInfo.icon }} {{ catInfo.label }}
          </button>

          <!-- SPECIAL GROUPS -->
          <div class="w-px h-10 bg-gray-200 mx-2 hidden md:block"></div>

          <button
            @click="selectedCategory = 'phone_validation'"
            :class="[
              'px-6 py-3 rounded-xl font-bold transition-all flex items-center gap-2',
              selectedCategory === 'phone_validation'
                ? 'bg-primary text-white shadow-lg'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            ]"
          >
            📱 Validation Phone
          </button>

          <button
            @click="selectedCategory = 'rates'"
            :class="[
              'px-6 py-3 rounded-xl font-bold transition-all flex items-center gap-2',
              selectedCategory === 'rates'
                ? 'bg-primary text-white shadow-lg'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            ]"
          >
            💱 Taux de change
          </button>
        </div>
      </div>
    </div>

    <!-- CONTENT -->
    <div class="animate-in fade-in slide-in-from-bottom-2 duration-300">
      <template v-if="selectedCategory === 'phone_validation'">
        <PhoneValidationFee :selected-country="selectedCountry" />
      </template>

      <template v-else-if="selectedCategory === 'rates'">
        <RatesConfig :selected-country="selectedCountry" />
      </template>

      <template v-else>
        <FeesConfig 
          :selected-country="selectedCountry" 
          :selected-category="selectedCategory" 
        />
      </template>
    </div>

  </PageLayout>
</template>

<script>
import { platform } from '@core/platform';
import FeesConfig from './FeesConfig.global.vue';
import PhoneValidationFee from './PhoneValidationFee.global.vue';
import RatesConfig from './RatesConfig.global.vue';

export default {
  name: 'FeesPage',

  components: {
    FeesConfig,
    PhoneValidationFee,
    RatesConfig
  },

  data() {
    return {
      selectedCountry: '',
      selectedCategory: ''
    };
  },

  mounted() {
    // Initialize with first country
    const countries = Object.keys(this.$constants.FEE.COUNTRIES);
    if (countries.length > 0) {
      this.selectedCountry = countries[0];
    }

    const categories = Object.keys(this.visibleCategories);
    if (categories.length > 0) {
      this.selectedCategory = categories[0];
    }
  },

  computed: {
    visibleCategories() {
      const categories = this.$constants.FEE.CATEGORIES || {};
      const config = platform.feeDashboardConfig || {
        hiddenCategories: [],
        hiddenOperations: []
      };

      return Object.fromEntries(
        Object.entries(categories).filter(([key]) => {
          if (key === 'wallet' && !platform.hasWallet) return false;
          if (config.hiddenCategories.includes(key)) return false;
          return true;
        })
      );
    }
  }
};
</script>

